import { CheckedIcon, InfoIcon } from 'ui/icons'
import { Typography, Tooltip } from '@frontend/design_system'
import { VEHICLE_BLOCK_FIELDS } from './constants'
import { NOT_AVAILABLE } from 'modules/Fleet/components/Vehicles/constants'
import { VehicleInformationBlockProps } from './types'
import styles from './styles.module.scss'
import { VEHICLE_DETAILS_FORM_VALUES } from 'texts/vehicleDetails'
import { CAR_TYPES_OPTIONS } from 'constants/termsAndConditions'

export const VehicleInformationBlock = ({
  values,
  vehicleDetailsData,
  bcrmCarCategory,
}: VehicleInformationBlockProps) => {
  const renderItem = (id: string, value?: string) => {
    let formatValue = value === NOT_AVAILABLE ? '' : value
    if (id === VEHICLE_DETAILS_FORM_VALUES.SEATS.ID) {
      formatValue = vehicleDetailsData?.seats.find(
        (seat) => seat.id === value
      )?.name
    } else if (id === VEHICLE_DETAILS_FORM_VALUES.DOORS.ID) {
      formatValue = vehicleDetailsData?.doors.find(
        (door) => door.id === value
      )?.name
    } else if (id === VEHICLE_DETAILS_FORM_VALUES.CAR_CATEGORY.ID) {
      formatValue = bcrmCarCategory
        ? CAR_TYPES_OPTIONS.find((el) => el.value === bcrmCarCategory)?.label
        : formatValue
    }

    const renderTooltip = (id: string) => {
      const tooltip = VEHICLE_BLOCK_FIELDS[id].TOOLTIP
      if (
        (id === VEHICLE_DETAILS_FORM_VALUES.CAR_CATEGORY.ID &&
          !bcrmCarCategory) ||
        !tooltip
      ) {
        return null
      } else
        return (
          <Tooltip popupContent={tooltip} size="primary" alignSelf="center">
            <InfoIcon color="blue700" size="small" />
          </Tooltip>
        )
    }

    return (
      <div
        className={styles['vehicle-item-info']}
        key={VEHICLE_BLOCK_FIELDS[id].LABEL}
      >
        <div className={styles['vehicle-item-info-icon']}>
          <CheckedIcon
            color={formatValue ? 'green700Master' : 'grey500'}
            size="medium"
          />
        </div>

        <Typography
          name="body1WBold"
          className={styles['vehicle-item-info-block']}
        >
          <span className={styles['vehicle-item-info-label']}>
            {VEHICLE_BLOCK_FIELDS[id].LABEL}
          </span>
          {renderTooltip(id)}
          <Typography
            name="body1WMedium"
            className={styles['vehicle-item-info-value']}
          >
            {formatValue || '-'}
          </Typography>
        </Typography>
      </div>
    )
  }

  return (
    <div>
      {Object.keys(VEHICLE_BLOCK_FIELDS).map((key: string) => {
        const value = values[key as keyof typeof values]
        return renderItem(key, value as string)
      })}
    </div>
  )
}
